import { css } from '@emotion/react'
import { Flow, Heading, Tag, Text } from 'bold-ui'
import { Box } from 'components/Box'
import { ReactNode } from 'react'

interface ServicoAssinaturaDigitalCardProps {
  habilitado: boolean
  titulo: string
  descricao: ReactNode
  children: ReactNode
}

export function ServicoAssinaturaDigitalCard(props: Readonly<ServicoAssinaturaDigitalCardProps>) {
  const { habilitado, titulo, descricao, children } = props

  return (
    <Box style={styles.card}>
      <Flow direction='vertical' justifyItems='start'>
        {habilitado ? (
          <Tag type='success' icon='checkCircleFilled'>
            Habilitado
          </Tag>
        ) : (
          <Tag type='normal' icon='banFilled'>
            Desabilitado
          </Tag>
        )}
        <Heading level={4}>{titulo}</Heading>
        <Text>{descricao}</Text>
      </Flow>
      <div css={styles.footer}>{children}</div>
    </Box>
  )
}

const styles = {
  card: css`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  `,
  footer: css`
    margin-top: auto;
  `,
}
